import React from "react";

export default (withBox) => {
  if (withBox.hasOwnProperty("withBox")) {
    return (
      <div className="loading-box pr">
        <div className="loading"></div>
      </div>
    );
  }

  return <div className="loading"></div>;
};
